import type { Project } from './types.ts';

/** Next free device tag for a prefix: Q1, Q2... skipping tags already used. */
export function nextTag(project: Project, prefix: string): string {
  const re = new RegExp(`^${prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(\\d+)$`);
  let max = 0;
  for (const e of Object.values(project.elements)) {
    const m = re.exec(e.tag);
    if (m) max = Math.max(max, Number(m[1]));
  }
  return `${prefix}${max + 1}`;
}

/** Next free single-line circuit letter: A..Z, then AA, AB... */
export function nextCircuitCode(project: Project): string {
  const used = new Set(Object.values(project.circuits).map((c) => c.code));
  for (let i = 0; ; i++) {
    const code = toLetters(i);
    if (!used.has(code)) return code;
  }
}

function toLetters(i: number): string {
  let s = '';
  let n = i + 1;
  while (n > 0) {
    const r = (n - 1) % 26;
    s = String.fromCharCode(65 + r) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}
